/*
  Находки реестра банкротств - вариант Б, 27.10.2026.

  Короткий список «кого нашёл реестр и что с подачей». Пункта в меню у экрана нет: человек
  приходит сюда кнопкой красной плашки дашборда (`RegistryFindingsBanner`). Решение
  принимается на карточке счёта, откуда видны долг и состав должников.

  Страницы режет сервер; решённые находки из списка уходят сами, поэтому пустой список -
  это «разобрано», а не ошибка.

  Страница - контейнер без разметки таблицы (§8.7).
*/

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client.js'
import { Empty, Loading, Notice } from '../components/Common.jsx'
import RegistryFindingsTable from '../components/RegistryFindingsTable.jsx'
import useServerPaging from '../components/useServerPaging.js'

export default function RegistryFindingsPage() {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [offset, setOffset] = useState(0)
  const { size, bar } = useServerPaging(offset, data?.total ?? 0, setOffset)

  useEffect(() => {
    api
      .registryFindings({ limit: size, offset })
      .then((page) => {
        setData(page)
        setError(null)
      })
      .catch(setError)
  }, [size, offset])

  return (
    <>
      <header className="head">
        <div>
          <h1 className="head__title">Находки реестра банкротств</h1>
          <div className="head__note">
            Служба сверяет должников портфеля с реестром. Уверенная находка останавливает подачу
            по счетам человека, пока вы не внесёте дату принятия заявления о банкротстве или не
            скажете, что это другой человек. Решение принимается на карточке счёта.
          </div>
        </div>
        <Link to="/dashboard" className="button button--quiet">
          К первому экрану
        </Link>
      </header>

      {error ? <Notice error={error} wide /> : null}
      {!data && !error ? <Loading what="Загружаем находки" /> : null}
      {data && data.items.length === 0 ? (
        <Empty title="Находок, ждущих решения, нет">
          Когда реестр найдёт кого-то из должников, он появится здесь и на первом экране.
        </Empty>
      ) : null}
      {data && data.items.length > 0 ? (
        <RegistryFindingsTable rows={data.items} bar={bar} />
      ) : null}
    </>
  )
}
